// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"styles_Spinner__XXk5_","spinner":"styles_spinner__q14HV"};